<template>
    <div :class="phoneClass || 'device-add-wrapper'" >
        <!--:style="{'height':show?'1340px':'1270px'} "-->
        <content-header :title="show ? $t('sideBar.editEquipment') : $t('sideBar.newEquipment') "></content-header>
        <div class="device-list-bg">
            <div class="device-section">
                <deviceAddNew></deviceAddNew>
            </div>
        </div>
    </div>
</template>
<script>
import Core from 'core/core'
import contentHeader from '../../components/content-header'
import deviceAddNew from '../../components/device-add-new'
import {refresh} from "core/winSize"
export default {
    data() {
        return {
	        phoneClass: '',
            msg:'',
            show: false
        };
    },
	created(){
		refresh(this,'phoneClass-device-add-wrapper');
		window.onresize = function(){
			setTimeout(function(){
				refresh(this,'phoneClass-idevice-add-wrapper');
			},10)
		};
	},
    components: {
        contentHeader,
        deviceAddNew
    },
    mounted() {
        this.show = this.$route.query.device_id
    },
    methods: {
    },
}
</script>

<style scoped lang="scss">
</style>
